// const BaseUrl = "http://localhost:8082";
//const BaseUrl = "http://10.8.0.4:8082";
//const BaseUrl = "https://mvsub.hkcl.net";
const BaseUrl = "https://mvsu.hkcl.net";
// const BaseUrl = "https://mvsu.ac.in";


export default BaseUrl;